/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionsContainer_viewer = {
    readonly id: string;
    readonly moderationScopes: {
        readonly scoped: boolean;
    } | null;
    readonly " $refType": "ModerationActionsContainer_viewer";
};
export type ModerationActionsContainer_viewer$data = ModerationActionsContainer_viewer;
export type ModerationActionsContainer_viewer$key = {
    readonly " $data"?: ModerationActionsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserModerationScopes",
            "kind": "LinkedField",
            "name": "moderationScopes",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scoped",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'cc293e3bc6e12c2a09d32bde17b637ff';
export default node;
